//This file is automatically rebuilt by the Cesium build process.
export default "in vec4 v_color;\n\
\n\
void main()\n\
{\n\
    out_FragColor = czm_gammaCorrect(v_color);\n\
}\n\
";